import { defineStore } from "pinia";
import { apiCall } from "../../utils/api";
import { ALL_RARITY } from "../../utils/constant";

export const useCardStore = defineStore("card", {
  state: () => ({
    cards: [],
  }),
  getters: {
    cardsObj: (state) => {
      const rtn = {};
      state.cards.forEach((item) => {
        rtn[item.id] = item;
      });
      return rtn;
    },
  },
  actions: {
    async getAll(force = false) {
      if (force || this.cards.length === 0) {
        const response = await apiCall("card.getAllCards", {});
        if (!response) {
          return false;
        }

        this.cards = response.sort((a, b) => {
          if (a.rarity === b.rarity) {
            return b.value - a.value;
          } else {
            return ALL_RARITY.indexOf(a.rarity) - ALL_RARITY.indexOf(b.rarity);
          }
        });
      }

      return true;
    },
  },
});
